export { default } from './ConsentSurvey';
